import { Component } from '@angular/core';

@Component({
  selector: 'zipari-design-system',
  template: ' <p>design-system works!</p> ',
  styles: [],
})
export class DesignSystemComponent {}
